module.exports = __webpack_public_path__ + "static/media/logo.1f9bb21c.svg";